import { Http } from '@/lib/http';

export class BranchService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/company-settings/branches/';
  }

  create(branch) {
    return this.httpClient().post(`${this.endpoint}`, branch);
  }

  findOne(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }

  findAll(filter = '', sort = '', paginate = { skip: 0, limit: -1 }) {
    let query = `${sort}`;
    query +=
      paginate.limit < 1
        ? ''
        : `&skip=${paginate.skip}&limit=${paginate.limit}`;
    return this.httpClient().get(`${this.endpoint}${filter}${query}`);
  }

  update(id, branch) {
    return this.httpClient().patch(`${this.endpoint}${id}`, branch);
  }

  delete(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
